import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <Toaster 
      position="bottom-center"
      toastOptions={{
        style: {
          background: 'var(--surface)',
          color: 'var(--text-primary)',
          border: '1px solid var(--border-color)',
          borderRadius: '12px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
          maxWidth: '500px', // Permet que creixi horitzontalment amb el missatge
          width: 'fit-content',
        },
        success: {
          iconTheme: {
            primary: 'var(--primary-color)',
            secondary: 'var(--surface)',
          },
        },
        error: {
          iconTheme: {
            primary: 'var(--danger-bg)',
            secondary: 'var(--surface)',
          },
        },
      }}
    />
    </ThemeProvider>
  </React.StrictMode>
);
